import { Skeleton } from '@sunwebgroup/ui-components/uds'
import styles from './MapAccoCard.module.css'

export function MapAccoCardLoading() {
  return (
    <div className={styles.accoCardContainer}>
      <Skeleton className={styles.imageContainer} />
      <div className={styles.cardMain}>
        <div className={styles.cardHeader}>
          <div className={styles.ratingWrapper}>
            <Skeleton className={styles.ratingSkeleton} />
          </div>
          <div className={styles.accoWrapper}>
            <Skeleton className={styles.nameSkeleton} />
            <Skeleton className={styles.breadcrumbsSkeleton} />
          </div>
        </div>
        <div className={styles.cardFooter}>
          <Skeleton className={styles.cardFooterSkeleton} />
        </div>
      </div>
    </div>
  )
}
